import classNames from 'classnames'
import { cloneDeep } from 'lodash'
import React, { useState, useEffect } from 'react'
import { Table, Panel, List, FlexboxGrid, Row, Col } from 'rsuite'
import { Icon, IconButton, ButtonGroup, Modal, Button } from 'rsuite'

export default function ReportResultView({ schema, onEdit, onDelete, ...props }) {
  const [tableData, setTableData] = useState(schema)
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const [isdelete, setIsdelete] = useState()
  const { isEdit } = props

  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    if (schema?.length > 0) {
      setTableData(schema)
    } else {
      setTableData([])
    }
  }, [schema])

  return (
    <Table wordWrap height={400} data={tableData}>
      <Column width={300}>
        <HeaderCell>
          <span>ผลลัพธ์</span>
        </HeaderCell>
        {/* <Cell dataKey="result" /> */}
        <Cell>
          {(rowData) => {
            return <div dangerouslySetInnerHTML={{ __html: rowData.result }} />
          }}
        </Cell>
      </Column>

      <Column width={300}>
        <HeaderCell>
          <span>ตัวชี้วัด</span>
        </HeaderCell>
        {/* <Cell dataKey="indicators" /> */}
        <Cell>
          {(rowData) => {
            return <div dangerouslySetInnerHTML={{ __html: rowData.indicators }} />
          }}
        </Cell>
      </Column>

      <Column width={300}>
        <HeaderCell>
          <span>ข้อมูลที่จะเก็บ</span>
        </HeaderCell>
        {/* <Cell dataKey="infoStored" /> */}
        <Cell>
          {(rowData) => {
            return <div dangerouslySetInnerHTML={{ __html: rowData.infoStored }} />
          }}
        </Cell>
      </Column>

      <Column width={300}>
        <HeaderCell>
          <span>วิธีเก็บข้อมูล</span>
        </HeaderCell>
        {/* <Cell dataKey="storageMethod" /> */}
        <Cell>
          {(rowData) => {
            return <div dangerouslySetInnerHTML={{ __html: rowData.storageMethod }} />
          }}
        </Cell>
      </Column>

      <Column width={190} fixed="right">
        <HeaderCell></HeaderCell>
        <Cell>
          {(rowData, index) => {
            return (
              <div>
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                    // onClick={() => handleEdit(rowData, index)}
                    onClick={() => onEdit(rowData, index)}
                  >
                    แก้ไข
                  </IconButton>

                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                    // onClick={() => {
                    //   setSelectedIndex(index)
                    //   setIsdelete(true)
                    // }}
                    onClick={() => onDelete(rowData, index)}
                  >
                    ลบ
                  </IconButton>
                </ButtonGroup>
              </div>
            )
          }}
        </Cell>
      </Column>
    </Table>
  )
}
